import state from './moduleRecipeState.js'
import mutations from './moduleRecipeMutations.js'
import actions from './moduleRecipeActions.js'
import getters from './moduleRecipeGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

